import { down, up } from 'styled-breakpoints'
import styled, { css } from 'styled-components'

export const Content = styled.div<{ isTablet?: boolean }>`
  position: relative;
  z-index: 2;

  ${up('lg')} {
    margin: 0 auto;
    width: 1120px;
    max-width: 100%;
  }

  ${down('md')} {
    margin: 0 auto;
    max-width: 96%;
  }

  ${down('md')} {
    max-width: 100%;
    margin: 0 14px;
  }

  /* Tablet için mobil stilleri uygula - en sonda olmalı ki diğer media query'leri override etsin */
  ${(props) =>
    props.isTablet &&
    css`
      max-width: 100% !important;
      margin: 0 14px !important;
      width: auto !important;
    `}
`

/**
 * SmartBanner 407 RTL slider: row-reverse + ters translate kullanıyor.
 * Sayfa dir=rtl iken flex çift ters dönüp boş slide / LTR dots çıkıyor —
 * geometry'yi LTR'de izole edip dots sırasını homepage isRTL ile veriyoruz.
 */
export const SmartBannerShell = styled.div<{ $isRtl?: boolean }>`
  [data-testid='smart-banner-slider-wrapper'],
  [data-testid='smart-banner-slider-track'],
  [data-testid='smart-banner-slider-dots'] {
    direction: ltr;
  }

  ${({ $isRtl }) =>
    $isRtl &&
    css`
      [data-testid='smart-banner-slider-dots'] {
        flex-direction: row-reverse;
      }
    `}
`
